// BRINGING A REFUSED FIELD INTO VIEW
//
// vee-validate renders an ErrorMessage (class error-message) beside every field it
// refused, and App.vue draws that field red. The first message in the form is the
// first refused field on screen, whatever order the errors object lists them in -
// which is why this reads the DOM rather than the errors.

import { nextTick } from "vue";

// A v-select opens its dropdown on focus, so it is scrolled to but not focused.
const FOCUSABLE = "input:not([type=hidden]):not(:disabled):not(.vs__search), textarea:not(:disabled), select:not(:disabled)";

const bringIntoView = (element) => {
  element.scrollIntoView({ behavior: "smooth", block: "center" });
  element.querySelector(FOCUSABLE)?.focus({ preventScroll: true });
};

// A message on screen is preferred to one inside something hidden. `openPage` is for
// a form spread over pages - tabs, a stepper - that are hidden rather than
// unmounted: it is handed the message, makes the page holding it the visible one,
// and resolves true if it had to switch.
async function revealInvalidField(container, openPage) {
  await nextTick();

  const messages = [...(container || document).querySelectorAll(".error-message")];
  const message = messages.find((m) => m.getClientRects().length > 0) || messages[0];
  if (!message) return false;

  if (openPage && (await openPage(message))) await nextTick();

  bringIntoView(message.parentElement);
  return true;
}

// For a form that checks itself instead of through vee-validate. The input stays red
// until it is next edited.
function flagInvalidInput(input) {
  if (!input) return;

  input.classList.add("field-invalid");
  input.addEventListener("input", () => input.classList.remove("field-invalid"), { once: true });
  input.addEventListener("change", () => input.classList.remove("field-invalid"), { once: true });

  input.scrollIntoView({ behavior: "smooth", block: "center" });
  input.focus({ preventScroll: true });
}

export { revealInvalidField, flagInvalidInput };
